// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"72":"9305e070","280":"fabd9f44","772":"cbd265aa"}[chunkId] + ".chunk.css");